export const Videotypes = {
  LANG_SEL: 'LANG_SEL',
  NAME: 'NAME',
  GENDER: 'GENDER',
  AGE: 'AGE',
  MOBILE: 'MOBILE',
  OTP: 'OTP',
  SELFIE: 'SELFIE',
  JOB_CITY: 'JOB_CITY',
  JOB_LOCALITY: 'JOB_LOCALITY',
  HOME: 'HOME',
  EDUCATION: 'EDUCATION',
  MARRIED: 'MARRIED',
  JOIN_DATE: 'JOIN_DATE',
  WORK_EX_QN: 'SKILS_QN',
  SKILLS: 'SKILLS',
  WORK_EX: 'WORK_EX',
  JOB_TYPE: 'JOB_TYPE',
  JOB_TIME_PREF: 'JOB_TIME_PREF',
  MIN_SAL: 'MIN_SAL',
  MITRA: 'MITRA',
  COMPLETED: 'COMPLETED',
  REQUEST_QN: 'REQUEST_QN',
  REQUEST_TO_UPLOAD: 'REQUEST_TO_UPLOAD',
  JOB_HR: 'JOB_HR',
  JOB_COMPANY: 'JOB_COMPANY',
  MITRA_CALL: 'MITRA_CALL',
  REQUEST_FOR_UPLOAD: 'REQUEST_FOR_UPLOAD',
};

export const VideoMap = {
  [Videotypes.LANG_SEL]: {
    en: 'https://vimeo.com/437825160/b60627918e',
    kn: 'https://vimeo.com/437851712/e3372284a8',
    hi: 'https://vimeo.com/437832471/7cc681fb3e',
  },
  [Videotypes.NAME]: {
    en: 'https://vimeo.com/437825722/03504c97f2',
    kn: 'https://vimeo.com/437851830/c3fbf877e0',
    hi: 'https://vimeo.com/437832622/93d6b17a2c',
  },
  [Videotypes.GENDER]: {
    en: 'https://vimeo.com/437825798/0dad92d906',
    kn: 'https://vimeo.com/437851908/2bfa46f633',
    hi: 'https://vimeo.com/437832808/6808411172',
  },
  [Videotypes.AGE]: {
    en: 'https://vimeo.com/437825873/7156da7859',
    kn: 'https://vimeo.com/437852009/28f500f10c',
    hi: 'https://vimeo.com/437832883/60a7810e25',
  },
  [Videotypes.MOBILE]: {
    en: 'https://vimeo.com/437825955/7551adc777',
    kn: 'https://vimeo.com/437852149/1c42206d09',
    hi: 'https://vimeo.com/437832986/d99cb42592',
  },
  [Videotypes.OTP]: {
    en: 'https://vimeo.com/437826004/5fefae3fbf',
    kn: 'https://vimeo.com/437852242/3c1556e88d',
    hi: 'https://vimeo.com/437833092/3d7f2e6ed0',
  },
  [Videotypes.SELFIE]: {
    en: 'https://vimeo.com/437826309/2bf5014f9c',
    kn: 'https://vimeo.com/437852331/4e56fbe355',
    hi: 'https://vimeo.com/437833200/28f5c34428',
  },
  [Videotypes.JOB_CITY]: {
    en: 'https://vimeo.com/437826506/2e859517fa',
    kn: 'https://vimeo.com/437852427/e548f81422',
    hi: 'https://vimeo.com/437833303/5666c00de4',
  },
  [Videotypes.JOB_LOCALITY]: {
    en: 'https://vimeo.com/437826649/182d4a49ab',
    kn: 'https://vimeo.com/437852545/a2604e6f66',
    hi: 'https://vimeo.com/437833431/45ecd8dad3',
  },
  [Videotypes.HOME]: {
    en: 'https://vimeo.com/437826776/c20b1c3bce',
    kn: 'https://vimeo.com/437852663/1ed83b5f72',
    hi: 'https://vimeo.com/437833554/89a622bbe6',
  },
  [Videotypes.EDUCATION]: {
    en: 'https://vimeo.com/437827835/bbb6507779',
    kn: 'https://vimeo.com/437852763/a3f89ee4fb',
    hi: 'https://vimeo.com/437833686/1d0d3f90fe',
  },
  [Videotypes.MARRIED]: {
    en: 'https://vimeo.com/437828176/82a72c51e7',
    kn: 'https://vimeo.com/437852891/0bcf7a8465',
    hi: 'https://vimeo.com/437840479/7cf6a3e744',
  },
  [Videotypes.JOIN_DATE]: {
    en: 'https://vimeo.com/437828479/330f04e880',
    kn: 'https://vimeo.com/437853049/f58d01e795',
    hi: 'https://vimeo.com/437841097/12208e667e',
  },
  [Videotypes.WORK_EX_QN]: {
    en: 'https://vimeo.com/437828889/70202a7ae4',
    kn: 'https://vimeo.com/437853182/7812c5ce41',
    hi: 'https://vimeo.com/437841844/0130f28c40',
  },
  [Videotypes.SKILLS]: {
    en: 'https://vimeo.com/437830694/e1664f732e',
    kn: 'https://vimeo.com/437853559/d754879d65',
    hi: 'https://vimeo.com/437843089/0ca9e42f6d',
  },
  [Videotypes.WORK_EX]: {
    en: 'https://vimeo.com/437829340/dd364e3162',
    kn: 'https://vimeo.com/437853297/0288f6dbb5',
    hi: 'https://vimeo.com/437842313/e85283a078',
  },
  [Videotypes.JOB_TYPE]: {
    en: 'https://vimeo.com/437829509/67f9419c69',
    kn: 'https://vimeo.com/437853429/3816a8cc88',
    hi: 'https://vimeo.com/437842762/004dccde85',
  },
  [Videotypes.JOB_TIME_PREF]: {
    en: 'https://vimeo.com/437830957/0eb17d840a',
    kn: 'https://vimeo.com/437853684/dd828c7805',
    hi: 'https://vimeo.com/437843350/554173ae5e',
  },
  [Videotypes.MIN_SAL]: {
    en: 'https://vimeo.com/437831112/3628dd466c',
    kn: 'https://vimeo.com/437853765/92b3481e28',
    hi: 'https://vimeo.com/437850608/ffb10458da',
  },
  [Videotypes.MITRA]: {
    en: 'https://vimeo.com/437831266/ffd695bdee',
    kn: 'https://vimeo.com/437853858/1d65d7ef85',
    hi: 'https://vimeo.com/437850679/4b5b9b8ca5',
  },
  [Videotypes.COMPLETED]: {
    en: 'https://vimeo.com/437831429/06a8509e11',
    kn: 'https://vimeo.com/437853951/ce012be8d9',
    hi: 'https://vimeo.com/437850838/bc2bd104e9',
  },
  [Videotypes.REQUEST_QN]: {
    en: 'https://vimeo.com/437831543/408f9210e2',
    kn: 'https://vimeo.com/437854053/b3c82df494',
    hi: 'https://vimeo.com/437850953/d6bf11382e',
  },
  [Videotypes.REQUEST_TO_UPLOAD]: {
    en: 'https://vimeo.com/437831649/7ac841d751',
    kn: 'https://vimeo.com/437854148/b2187db4a3',
    hi: 'https://vimeo.com/437851072/569cce8ba8',
  },
  [Videotypes.JOB_HR]: {
    en: 'https://vimeo.com/437831802/be7488e7b2',
    kn: 'https://vimeo.com/437854261/942182809d',
    hi: 'https://vimeo.com/437851183/35630bbaba',
  },
  [Videotypes.JOB_COMPANY]: {
    en: 'https://vimeo.com/437831967/3c2003b98e',
    kn: 'https://vimeo.com/437854261/942182809d',
    hi: 'https://vimeo.com/437851327/63607a0423',
  },
  [Videotypes.MITRA_CALL]: {
    en: 'https://vimeo.com/437832204/e31fedc5b7',
    kn: 'https://vimeo.com/437854366/88aed49705',
    hi: 'https://vimeo.com/437851493/aba96c81dc',
  },
  [Videotypes.REQUEST_FOR_UPLOAD]: {
    en: 'https://vimeo.com/437832322/273be7d4b5',
    kn: 'https://vimeo.com/437854572/8571b67f1b',
    hi: 'https://vimeo.com/437851639/c3eb8c83af',
  },
};

export const OnBoardingV2Videos = {
  hi: [
    'https://player.vimeo.com/external/437832471.sd.mp4?s=d958eb4a963b1ef2b6fd995ce6bef6b0a739d95e&profile_id=164',
    'https://player.vimeo.com/external/437832622.sd.mp4?s=3256e740848d0322284eae93f8995d5bc9e7723b&profile_id=164',
    'https://player.vimeo.com/external/437832808.sd.mp4?s=36611ceae93e29a7719bad174e3f0da75fecba32&profile_id=164',
    'https://player.vimeo.com/external/437832883.sd.mp4?s=519ff76772043e176444c46b4e6e53328530a81a&profile_id=164',
    'https://player.vimeo.com/external/437832986.sd.mp4?s=dcef17b82f87f4eb2cb2225effccb4f92691e5e1&profile_id=164',
    'https://player.vimeo.com/external/437833092.sd.mp4?s=5b8b22002ded8a6940c838bf5f8fef92385919d4&profile_id=164',
    'https://player.vimeo.com/external/437833200.sd.mp4?s=66fae097d91316fae95ba38669ca8bf0458ecc75&profile_id=164',
    'https://player.vimeo.com/external/437833303.sd.mp4?s=40de1ad3a8c75f404132d40bb59e19844dd1062c&profile_id=164',
    'https://player.vimeo.com/external/437833431.sd.mp4?s=4856bb7373758708d368bddac5fc0b1fb55d65de&profile_id=164',
    'https://player.vimeo.com/external/437833554.sd.mp4?s=a936c5cc881e1eee0632132fff0ed95225169345&profile_id=164',
    'https://player.vimeo.com/external/437833686.sd.mp4?s=e43645bffca8a8650f4c1f1677b2cb2a47d45499&profile_id=164',
    'https://player.vimeo.com/external/437840479.sd.mp4?s=d1d26dd6f3fb53574bc7fb74000c9ebac6ddf81a&profile_id=164',
    'https://player.vimeo.com/external/437841097.sd.mp4?s=b4e9fe076b15a255441640c1b8b18f44d8b838a7&profile_id=164',
    'https://player.vimeo.com/external/437841844.sd.mp4?s=579d134fce68ea69f7d47b4cce9bf4c63a17266d&profile_id=164',
    'https://player.vimeo.com/external/437843089.sd.mp4?s=57aa6b7079251bfc12011122065de029004460bb&profile_id=164',
    'https://player.vimeo.com/external/437842313.sd.mp4?s=ecb1f545248d95ca95438e4284efa22a1ef0dbca&profile_id=164',
    'https://player.vimeo.com/external/437842762.sd.mp4?s=26265843031dcf8d7b887936492f926653f7dc3d&profile_id=164',
    'https://player.vimeo.com/external/437843350.sd.mp4?s=46280512fa1865e2a7767bc6ede50ee408345cb5&profile_id=164',
    'https://player.vimeo.com/external/437850608.sd.mp4?s=de13f11423aa5efd879b7833a4d2384a3629a250&profile_id=164',
    'https://player.vimeo.com/external/437850679.sd.mp4?s=5d1269511c9c1f02d3c0ccc0bc54af3470ddc782&profile_id=164',
    'https://player.vimeo.com/external/437850838.sd.mp4?s=edf49cc34a04cdd411a94eb9bde7b68c4cdf3406&profile_id=164',
  ],
  en: [
    'https://player.vimeo.com/external/437825160.sd.mp4?s=313cde8ad1f2a8729784a52f74a1b8088b11852b&profile_id=164',
    'https://player.vimeo.com/external/437825722.sd.mp4?s=699c3117cb562732d1b0508223e438271c303b3e&profile_id=164',
    'https://player.vimeo.com/external/437825798.sd.mp4?s=c4a5c91e8a55148c0663420ddf8efaf17fdb8bab&profile_id=164',
    'https://player.vimeo.com/external/437825873.sd.mp4?s=9d9e071260a3353981fbc1a602fcec7588bbf7ea&profile_id=164',
    'https://player.vimeo.com/external/437825955.sd.mp4?s=48668b4ce8b42120995d047af556966d06e9d462&profile_id=164',
    'https://player.vimeo.com/external/437826004.sd.mp4?s=95256843825660e94caf87725ce3a869283ec215&profile_id=164',
    'https://player.vimeo.com/external/437826309.sd.mp4?s=e144b10702589a55ff970ac4a40785b4224eee42&profile_id=164',
    'https://player.vimeo.com/external/437826506.sd.mp4?s=33be603e959ea89b1e83f9aa18c01d5b1de75579&profile_id=164',
    'https://player.vimeo.com/external/437826649.sd.mp4?s=6b22c5d823fc5aab06feba9497969a9581261ab1&profile_id=164',
    'https://player.vimeo.com/external/437826776.sd.mp4?s=e295f83c94708691d6d0cddcdad8946072433307&profile_id=164',
    'https://player.vimeo.com/external/437827835.sd.mp4?s=58a78ef2f9946d5fd6766bb7dc882c947982657a&profile_id=164',
    'https://player.vimeo.com/external/437828176.sd.mp4?s=640b93b2d5150931f14a98432915e2678a0a04b6&profile_id=164',
    'https://player.vimeo.com/external/437828479.sd.mp4?s=90cbdd12fc3df94fa442d5d37d9e7344b0678dc2&profile_id=164',
    'https://player.vimeo.com/external/437828889.sd.mp4?s=152034137e5e742d0cb61cc6a87c99188b1a88b8&profile_id=164',
    'https://player.vimeo.com/external/437830694.sd.mp4?s=e461d3568b74c8027c3f70ab663ce34626abf1e5&profile_id=164',
    'https://player.vimeo.com/external/437829340.sd.mp4?s=e62992bac8a1656ac7719793417635b6e2899bf6&profile_id=164',
    'https://player.vimeo.com/external/437829509.sd.mp4?s=13573752c50f9d235d17f2603cccb3a25727d170&profile_id=164',
    'https://player.vimeo.com/external/437830957.sd.mp4?s=aaa6b1381e54fe7b2fb64d692594518e296a16a1&profile_id=164',
    'https://player.vimeo.com/external/437831112.sd.mp4?s=c53b1e3ed3606f30b92031e2d42be32ed21a192d&profile_id=164',
    'https://player.vimeo.com/external/437831266.sd.mp4?s=41f70f6a266844885db068ce34fbc051218ae0ba&profile_id=164',
    'https://player.vimeo.com/external/437831429.sd.mp4?s=516e49571d091d701518e99109cf5175312c1d5c&profile_id=164',
  ],
  kn: [
    'https://player.vimeo.com/external/437851712.sd.mp4?s=bfb2a9ff6240356efab8fafec9ff508890979bce&profile_id=164',
    'https://player.vimeo.com/external/437851830.sd.mp4?s=43c82786d77419664d69c47d9825a3c56da63b3f&profile_id=164',
    'https://player.vimeo.com/external/437851908.sd.mp4?s=ff8f92ff53276eff93191cca1e9007b7d0137f23&profile_id=164',
    'https://player.vimeo.com/external/437852009.sd.mp4?s=596a2bd7137064999e7933b3cee99875d14a30f1&profile_id=164',
    'https://player.vimeo.com/external/437852149.sd.mp4?s=7cb6919f4e04296fdc59886d8a3f4e009f35aa61&profile_id=164',
    'https://player.vimeo.com/external/437852242.sd.mp4?s=7489fa1bfde6c4588cc9775d23d25a477c0187f5&profile_id=164',
    'https://player.vimeo.com/external/437852331.sd.mp4?s=f782084b6a21529e96c69bef38c32fb208e3c17d&profile_id=164',
    'https://player.vimeo.com/external/437852427.sd.mp4?s=bb6e4d55e0ae57a5906a1c408ddccec1c033d7a8&profile_id=164',
    'https://player.vimeo.com/external/437852545.sd.mp4?s=f6b404142449358116f1a5af60a5633ad428946f&profile_id=164',
    'https://player.vimeo.com/external/437852663.sd.mp4?s=5814147e9cac30ded5979c7a24d8500cf93d4b9b&profile_id=164',
    'https://player.vimeo.com/external/437852763.sd.mp4?s=38fb45b0fea9dc3595165f119b5785e797a9d5ad&profile_id=164',
    'https://player.vimeo.com/external/437852891.sd.mp4?s=40f85d5b0b1086e0bc1dd2cb033e7520b2a1bb1f&profile_id=164',
    'https://player.vimeo.com/external/437853049.sd.mp4?s=7d53ede83d3420b32dab5b9fd6604fa4edf67be7&profile_id=164',
    'https://player.vimeo.com/external/437853182.sd.mp4?s=9521ab09854f75ae3ff50e6b1ea21bafaf595246&profile_id=164',
    'https://player.vimeo.com/external/437853559.sd.mp4?s=17b9c899dbda0584a6b4aee6df0f92893994a1fc&profile_id=164',
    'https://player.vimeo.com/external/437853297.sd.mp4?s=cf5fe8f49110354996474f7a312b6a3d34dd627d&profile_id=164',
    'https://player.vimeo.com/external/437853429.sd.mp4?s=1c261340831d2f78b6090b504bbe26ea5a0c0d98&profile_id=164',
    'https://player.vimeo.com/external/437853684.sd.mp4?s=8064877d3410b8bd2011fe7964b249d7a564af25&profile_id=164',
    'https://player.vimeo.com/external/437853765.sd.mp4?s=4037e43e78c8ec3c4fb7ffc1bad03bb287830872&profile_id=164',
    'https://player.vimeo.com/external/437853858.sd.mp4?s=ef79e8a9f76715398639025a9f2176df4bf13c1c&profile_id=164',
    'https://player.vimeo.com/external/437853951.sd.mp4?s=b88636cf30f437623242988e508b0993ebbc2649&profile_id=164',
  ],
};
